import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-user-bulk-disable',
		path: '/admin/bulk_disable_users',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-user-bulkDisable" */ './index'), {
			exportName: 'BulkDisableUsers',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support'],
		},
		frame: true,
	},
];
